import { DialogTitle } from "../shared/modal";
import { useLikedColors } from "../../../js/api/my-saved-colors/get-liked-colors";
import { useMyLikedColorsStore } from "../../../js/stores/my-liked-colors-store";
import { ErrorContent } from "../shared/error-content";
import { LoadingContent } from "../shared/loading-content";
import { LoggedOffColorItem } from "./logged-off-color-item";

export function LoggedOffColors() {
  const likedColors = useMyLikedColorsStore((state) => state.likedColors);
  const resetColors = useMyLikedColorsStore((state) => state.resetColors);
  const { data, isLoading, isError, isFetching } = useLikedColors(likedColors);
  const isEmpty = !isLoading && !isFetching && !data?.items?.length;
  const onClearAllClick = () => {
    resetColors();
  };

  if (isLoading) {
    return <LoadingContent />;
  }

  if (isError) {
    return <ErrorContent />;
  }

  return (
    <>
      <div className="saved-colors-header">
        <DialogTitle className="saved-colors-title saved-colors-title--position">
          {data?.modalLabel}
        </DialogTitle>
        {data?.clearAllAction && !isEmpty && (
          <button
            className="saved-colors-tertiary-action saved-colors-tertiary-action--position"
            type="button"
            onClick={onClearAllClick}
          >
            {data?.clearAllAction?.linkLabel}
          </button>
        )}
      </div>
      {isEmpty && (
        <div className="saved-colors-loading-container saved-colors-loading-container--no-top-padding">
          {data?.emptyStateText}
        </div>
      )}
      {!isEmpty && (
        <>
          <div className="saved-colors-main">
            <div className="saved-colors-grid">
              {data?.items?.slice(0, 20)?.map((color) => (
                <LoggedOffColorItem
                  key={color.colourCode}
                  name={color.colourName}
                  rgb={color.colourRGB}
                  colourCode={color.colourCode}
                  colourActions={color.colourActions}
                  isTrending={color.isTrending}
                />
              ))}
            </div>
          </div>
          <div className="saved-colors-footer">
            {data?.actionTipText && (
              <p className="saved-colors-footer-tip">{data?.actionTipText}</p>
            )}
            {data?.secondaryAction && (
              <a
                className="saved-colors-action saved-colors-action--secondary"
                href={data?.secondaryAction.linkUrl}
              >
                {data?.secondaryAction?.linkLabel}
              </a>
            )}
            {data?.mainAction && (
              <a
                className="saved-colors-action saved-colors-action--main"
                href={data?.mainAction.linkUrl}
              >
                {data?.mainAction?.linkLabel}
              </a>
            )}
          </div>
        </>
      )}
    </>
  );
}
